import { dataProvider } from "./dataProvider";

// jve-7: the multi-step create flow makes two calls in sequence (create account, then issue a
// credential), which doesn't map to a single Refine mutation — so it stays a small domain-facing
// module rather than a useCreate hook. jve-2-4: both calls now route through the shared dataProvider
// (create + custom) instead of a duplicate fetch helper, so create flows through the provider and the
// bearer/error handling lives in exactly one place.

export interface CreatedAccount {
  id: string;
  name: string;
}

export interface IssuedCredential {
  clientId: string;
  clientSecret: string;
  secretPrefix: string;
}

export async function createServiceAccount(name: string, authorities: string[]): Promise<CreatedAccount> {
  const { data } = await dataProvider.create({
    resource: "service-accounts",
    variables: { name, authorities },
  });
  return data as unknown as CreatedAccount;
}

export async function issueCredential(id: string): Promise<IssuedCredential> {
  const { data } = await dataProvider.custom!<IssuedCredential>({
    url: `service-accounts/${id}/credentials`,
    method: "post",
  });
  return data;
}
